<template>
  <v-container fluid>
    <!-- <h1>hellwo</h1> -->
    <v-row justify="center">
      <v-col cols="12" class="d-none d-md-flex justify-center">
        <v-toolbar dense color="grey darken-1 ">
          <v-spacer></v-spacer>
          <v-toolbar-items class="mb-3">
            <ExpensGroup
              :fromDate="fromDate"
              :toDate="toDate"
              colorName="white"
              :isloading="searching"
              :Balance="GroupBy"
            ></ExpensGroup>
          </v-toolbar-items>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
      <v-col cols="10">
        <v-card>
          <v-card-title v-if="ReportData.length">
            <v-chip-group column light>
              <v-chip color="error" outlined
                ><strong
                  >TotalExpense:
                  <span class="green--text">
                    {{ TotalExpense.toLocaleString() }}</span
                  ></strong
                >
              </v-chip>
            </v-chip-group>

            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :loading="searching"
            :headers="headers"
            :items="ReportData"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <searchDate
                  :searching="searching"
                  :SearchFun="OnSearch"
                  Thismonth
                ></searchDate>
              </v-toolbar>
            </template>

            <template v-slot:[`item.Amount`]="{ item }">
              {{ item.Amount.toLocaleString() }}
            </template>

            <template v-slot:[`item.tran`]="{ item }">
              <!-- <OwnerTransaction :OwnerInfo="item"></OwnerTransaction> -->
              <!-- <P>{{ item }}</P> -->
              <ExpenseTran
                :BaseURL="ExpenseURL"
                queryKey="Account"
                :Title="item.AccountName"
                :TranInfo="item"
                :headers="tranHeader"
              >
                <template v-slot:Details="{ row }">
                  {{ row.Details.replace("Expense", item.AccountName) }}
                </template>
                <template v-slot:deposit="{ row }">
                  <template v-if="row.Acc == 'Cr'">
                    {{ Math.abs(row.Amount).toLocaleString() }}
                    {{ row.AmountType | MoneySigns }}
                  </template>
                  <p v-else></p>
                </template>
                <template v-slot:withdraw="{ row }">
                  <template v-if="row.Acc == 'Dr'">
                    {{ Math.abs(row.Amount).toLocaleString() }}
                    {{ row.AmountType | MoneySigns }}
                  </template>
                  <p v-else>--------</p>
                </template>
              </ExpenseTran>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { allReq } from "@/axiosfiles/axios-outh";
// import axios from "axios";
// import _ from "lodash";

export default {
  components: {
    ExpensGroup: () => import("@/components/Branches/Expense/ExpenseGroup.vue"),
    searchDate: () => import("@/components/util/searchDate.vue"),
    ExpenseTran: () => import("@/components/util/TranSactionView.vue"),
  },
  data() {
    return {
      searching: false,
      ExpenseURL: "/Reports/expense",
      search: "",
      fromDate: "",
      toDate: "",
      headers: [
        {
          text: "Expense type",
          align: "left",
          value: "type",
          class: "grey darken-1 white--text",
        },
        {
          text: "Expense",
          align: "left",
          value: "AccountName",
          class: "grey darken-1 white--text",
        },

        {
          text: "Amount",
          value: "Amount",
          class: "grey darken-1 white--text",
        },
        {
          text: "Tran",
          value: "tran",
          class: "grey darken-1 white--text",
        },
      ],
      tranHeader: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Reason", value: "expensName" },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
      ReportData: [],
      GroupBy: [],
      EmptyMessage: "",
      dialog: false,
    };
  },
  computed: {
    TotalExpense() {
      return this.ReportData.reduce((total, item) => {
        return (total += item.Amount);
      }, 0);
    },
  },

  methods: {
    TranSactions(from, to) {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.ExpenseURL,
        query: { from, to },
      });

      // this.$store.dispatch("INSERT_ONLY", {
      //   url: "/qarash/allexpense",
      //   data: {
      //     from,
      //     to
      //   }
      // });
    },

    close() {
      this.dialog = false;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;
      this.ReportData = [];
      this.GroupBy = [];

      this.searching = true;
      this.TranSactions(this.fromDate, this.toDate)
        .then(result => {
          this.ReportData = result.data.expense;
          this.GroupBy = result.data.Group;
          // console.log(result);

          this.searching = false;
        })
        .catch(() => {
          // console.log(error);
          this.searching = false;
        });
    },
  },
  created() {
    this.ReportData = [];
    this.GroupBy = [];
    this.searching = true;
    let date = this.Current();
    this.fromDate = date.Thismonth;
    this.toDate = date.date;
    this.TranSactions(this.fromDate, this.toDate)
      .then(result => {
        // console.log(result);
        this.ReportData = result.data.expense;
        this.GroupBy = result.data.Group;
        this.searching = false;
      })
      .catch(() => {
        // console.log(error);
        this.searching = false;
      });
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double red;
}
</style>
